<div class="title">{{ titleKey() | translate }}</div>

<div class="subtitle-container">
    <div class="subtitle">{{ subtitleKey() | translate }}</div>
    @let subtitleKeyInnerHtml = this.subtitleKeyInnerHtml();
    @if (subtitleKeyInnerHtml) {
        <!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
        <div class="subtitle-inner-html" [innerHtml]="subtitleKeyInnerHtml | translate"></div>
    }
</div>

<div class="button-container">
    @if (hasAction()) {
        <warema-button
            [href]="actionRedirectUrl()"
            [iconLeft]="iconLeft()"
            [iconRight]="iconRight()"
            [id]="buttonId()"
            [size]="isButtonSmall() ? 'small' : 'large'"
            [target]="isRedirectOnNewTab() ? '_blank' : '_self'"
            [text]="actionTextKey() | translate"
        />
    }
</div>
